import React, { useCallback } from 'react';
import { OutlinedButton, PrimaryButton } from '@bloomberg/media-ui-core';
import { ExitThin, Lock } from '@bloomberg/media-ui-icons';

import styles from './AddToWatchlistLoggedOut.module.css';

type AddToWatchlistLoggedOutProps = {
  onClose: () => void;
  onSignInClick: () => void;
  onCreateAccountClick: () => void;
};

const DESCRIPTION_MESSAGE =
  'Sign in to follow this symbol and get relevant news in one place.';

export const AddToWatchlistLoggedOut = (
  props: AddToWatchlistLoggedOutProps
) => {
  const { onClose, onCreateAccountClick, onSignInClick } = props;

  const openSignInModal = useCallback(() => {
    onSignInClick();
  }, [onSignInClick]);

  const openCreateAccountModal = useCallback(() => {
    onCreateAccountClick();
  }, [onCreateAccountClick]);

  return (
    <div className={styles.addToWatchlistLoggedOut}>
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <Lock />
          <p>Add to watchlist</p>
        </div>
        <button className={styles.closeButton} onClick={onClose}>
          <ExitThin />
        </button>
      </div>
      <p className={styles.description}>{DESCRIPTION_MESSAGE}</p>
      <div className={styles.buttonsContainer}>
        <OutlinedButton
          className={styles.createAccountButton}
          onClick={openCreateAccountModal}
          size="small"
          title="create account"
          version="phoenix"
        >
          Create account
        </OutlinedButton>
        <PrimaryButton
          className={styles.signInButton}
          onClick={openSignInModal}
          size="small"
          title="sign in"
          version="phoenix"
        >
          Sign In
        </PrimaryButton>
      </div>
    </div>
  );
};
